import { COLOR_KEYS_LIST } from '../../constants';
export const tagLabelConfig = {
    name: 'TagLabel',
    category: 'Zapier Blocks',
    image: 'https://cdn.zappy.app/e336d50f7ddf3c8f6d0beb215d5014a7.png',
    inputs: [
        {
            name: 'text',
            type: 'richText',
            required: true,
        },
        {
            name: 'color',
            type: 'string',
            enum: COLOR_KEYS_LIST,
        },
        {
            name: 'size',
            type: 'string',
            enum: ['small', 'medium'],
        },
    ],
};
//# sourceMappingURL=config.js.map